export default __webpack_public_path__ + "static/media/dev.434888bf.svg";